export const EVENT_CODES = {
  space: 'Space',
  tab: 'Tab'
}
